import axios from "axios";
import { toast } from "react-toastify";
import { retrieveToken } from "../utils/cryptoStorage";

const API_URL = import.meta.env.VITE_API_URL_NOTIFICATION;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = retrieveToken("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.error("Authorization token is not available.");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const handleError = (error) => {
  if (error.isAxiosError && error.response) {
    const data = error.response.data || {};
    const statusCode =
      data.statusCode ?? data.status ?? error.response.status;
    const message = data.message || data.errorMsg || data.error;

    if (message) {
      toast.error(message);
    }
    switch (statusCode) {
      case 500:
        throw new Error(
          "Server Error (500): The server encountered an issue. Please try again later."
        );
      case 422:
        throw new Error(
          "Validation Error (422): Invalid or incomplete data provided."
        );
      case 401:
        localStorage.clear();
        window.location.href = "/login";
        throw new Error(
          "Unauthorized (401): Access is denied. Please check your login status."
        );
      default:
        throw new Error(`API Error: Received unexpected status code ${statusCode}`);
    }
  } else {
    throw new Error(error.message || "An unexpected error occurred.");
  }
};

export const ApprovalNotificationListing = async (
  page = 1,
  perPage = 10,
  status,
  userId,
  title,
  alertDate,
  expiryDate,
  notificationType,
  wardCode
) => {
  try {
    let url = `/notification-admin/v1?page=${page}&perPage=${perPage}&status=${status}&isMyNotification=0&createdUserId=${userId}`;
    if (title?.length > 0) url += `&title=${encodeURIComponent(title)}`;
    if (alertDate) url += `&alertDate=${alertDate}`;
    if (expiryDate) url += `&expiryDate=${expiryDate}`;
    if (notificationType != null) url += `&notificationType=${notificationType}`;
    if (wardCode?.length > 0) url += `&wardCode=${wardCode}`;

    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};

export const notificationStatusUpdate = async (data) => {
  try {
    const response = await axiosInstance.put("/notification-status/v1", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
